module.exports = __webpack_public_path__ + "img/profile_icon.d9f2a6d3.svg";